import {atom} from 'recoil'

export const currentViewState = atom<number>({
    key: "currentViewStateBuilder",
    default: 0
})